import React from 'react';

import {OEFNWelcomeEntryTypes} from '../../views/flow-nav/welcome/oe-fn-welcome-model';
import OEProtoStartView, {OEProtoStartViewEntryTypes} from '../oe-proto-start-view';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEThiemeTargetType, OEThiemeTargets, OEThiemeFeatureAccess, OEThiemeStartSelectionData} from './oe-thieme-model';
import {OEFlowNavModalFlags} from '../../views/flow-nav/oe-flow-nav-modal';
import {OEFNHelpEntryType} from '../../views/flow-nav/help/oe-flow-nav-help-model';

export default class OEThiemeStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.entries = [
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: true}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '3.375em' /*54*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                {type: OEProtoStartViewEntryTypes.targetType, targetType: OEThiemeTargetType.anatomy, stringId: 'target_menu_anatomy', icon: OEIconCodes.thieme.anatomyTarget},
                {type: OEProtoStartViewEntryTypes.targetType, targetType: OEThiemeTargetType.head, stringId: 'target_menu_head', icon: OEIconCodes.thieme.headTarget},
                {type: OEProtoStartViewEntryTypes.targetType, targetType: OEThiemeTargetType.biology, stringId: 'target_menu_biology', icon: OEIconCodes.thieme.biologyTarget},                
                {type: OEFNWelcomeEntryTypes.spacer, height: '2em' /*32*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/}
            ]},
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: false}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '4.625em' /*74*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEFNWelcomeEntryTypes.licensing},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2.25em' /*36*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEProtoStartViewEntryTypes.demo, targetType: OEThiemeTargetType.head, stringId: 'target_menu_head', icon: OEIconCodes.thieme.headTarget},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2.125em' /*34*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/}
            ]},
            {type: OEFNWelcomeEntryTypes.help, stringId: 'welcome_view_help_target_menu', className: 'help-entry', flowNavModalFlags: OEFlowNavModalFlags.closeOnToggle},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.5em' /*24*/}
        ];
    }

    render()    {

        let infoHelp = {
            entries: [
                {type: OEFNHelpEntryType.spacer, height: '3.5em' /*56*/},
                {type: OEFNHelpEntryType.text, stringId: 'info_help_text'},
                {type: OEFNHelpEntryType.spacer, height: '1.125em' /*18*/},
                {type: OEFNHelpEntryType.text, stringId: 'info_help_text_2'},
                {type: OEFNHelpEntryType.spacer, height: '2.5em' /*40*/},
                {type: OEFNHelpEntryType.usageRights},
                {type: OEFNHelpEntryType.licenseAgreement},
                {type: OEFNHelpEntryType.spacer, height: '2.125em' /*34*/},
                {type: OEFNHelpEntryType.credits},
                {type: OEFNHelpEntryType.feedback},
            ]
        };

        let infoHelpDefault = {
            entries: [
                {type: OEFNHelpEntryType.spacer, height: '4.625em' /*74*/},
                {type: OEFNHelpEntryType.usageRights},
                {type: OEFNHelpEntryType.licenseAgreement},
                {type: OEFNHelpEntryType.spacer, height: '2.125em' /*34*/},
                {type: OEFNHelpEntryType.credits},
                {type: OEFNHelpEntryType.feedback},
            ]
        };

        return (
            <OEProtoStartView
                {...this.props}
                entries={this.entries}
                infoHelp={infoHelp}
                versionTargets={OEThiemeTargets}
                featureAccess={OEThiemeFeatureAccess}
                startSelectionData={OEThiemeStartSelectionData}
            />
        );
    }
}